// **************************** DESKTOP - NAVBAR ****************************

const path = window.location.pathname;
const navLinks = document.querySelectorAll("nav a");
const allSpans = document.querySelectorAll("span");

navLinks.forEach((link) => {
    const span = link.querySelector("span");

    link.style.textDecoration = "none !important";

    if (span && link.getAttribute("href") === path) {
        span.classList.add("active_link");
    }
});

// **************************** BOUTIQUE PAGE ****************************
// Removed this on May 01, 2025 as per the instructions here https://www.notion.so/martin-anev/Boutique-page-updates-68c0b3a32b9f421bac86328178a1351e?pvs=4
// let clickableColumn = document.getElementById(
//     "Slide-template--16171214602307__multicolumn_d7zirU-2"
// );
// if (clickableColumn != null) {
//     clickableColumn.addEventListener("click", function (event) {
//         const columnHeight = clickableColumn.offsetHeight;
//         const clickPosition =
//             event.clientY - clickableColumn.getBoundingClientRect().top;

//         if (clickPosition > columnHeight / 2) {
//             const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

//             if (isMobile) {
//                 window.open(
//                     "https://www.google.com/maps/search/?api=1&query=33.541679,-117.777214",
//                     "_blank"
//                 );
//             } else {
//                 window.open("https://maps.app.goo.gl/GybMbKAcSn2vqvhe6", "_blank");
//             }
//         }
//     });
// }
// **************************** DESKTOP - SINGLE PRODUCT PAGE ****************************

const button = document.getElementById("ProductSubmitButton-");

if (button) {
    const span = button.querySelector("span");

    if (span) {
        span.innerHTML =
            'Add to Shopping Bag <svg id="cart-icon-btn" class="icon icon-cart-empty" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path d="m15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.78-11.61zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1 -9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z" fill="currentColor" fill-rule="evenodd"></path></svg>';
    }
}

// Fix for "Discover more" buttons in accordion panels - LIGHTWEIGHT VERSION
document.addEventListener("DOMContentLoaded", function () {
    // Simple one-time setup of event delegation 
    document.body.addEventListener('click', function (e) {
        // Check if the clicked element is a "Discover more" button
        if (e.target.classList && e.target.classList.contains('accordion-link') ||
            (e.target.parentNode && e.target.parentNode.classList && e.target.parentNode.classList.contains('accordion-link'))) {

            // Stop event from bubbling to prevent accordion toggle
            e.stopPropagation();

            // Find the button (might be the SVG or path inside that was clicked)
            let button = e.target;
            while (button && !button.classList.contains('accordion-link')) {
                button = button.parentNode;
            }

            if (button) {
                // Find the discover section within the same parent div
                const container = button.closest('div');
                if (container) {
                    const discoverSection = container.querySelector('.discover-section');
                    if (discoverSection) {
                        // Get the text part of the button (excluding the SVG)
                        let buttonTextNode = Array.from(button.childNodes)
                            .find(node => node.nodeType === Node.TEXT_NODE);

                        // Toggle visibility and change button text
                        if (discoverSection.style.display === 'block') {
                            discoverSection.style.display = 'none';
                            if (buttonTextNode) {
                                buttonTextNode.nodeValue = 'Discover more ';
                            }
                        } else {
                            discoverSection.style.display = 'block';
                            if (buttonTextNode) {
                                buttonTextNode.nodeValue = 'Show less ';
                            }
                        }
                    }
                }
            }
        }
    }, true); // Use capture to intercept events before they reach accordions
});

// Simple direct accordion management - mobile friendly
document.addEventListener("DOMContentLoaded", function () {
    // Set up Accordion functionality
    var acc = document.getElementsByClassName("accordion");

    function handleAccordionToggle() {
        // Toggle this panel
        var panel = this.nextElementSibling;
        var arrow = this.querySelector('.arrow');

        if (panel.style.display === "block") {
            panel.style.display = "none";
            if (arrow) arrow.textContent = "▼";
        } else {
            panel.style.display = "block";
            if (arrow) arrow.textContent = "▲";
        }
    }

    // Set up initial state and event listeners
    for (var i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", handleAccordionToggle);

        // If there's a URL param matching this accordion's ID, open it
        const urlParams = new URLSearchParams(window.location.search);
        const sectionParam = urlParams.get('section');

        if (sectionParam && acc[i].id === sectionParam) {
            var panel = acc[i].nextElementSibling;
            var arrow = acc[i].querySelector('.arrow');

            if (panel) {
                panel.style.display = "block";
                if (arrow) arrow.textContent = "▲";
            }
        }
    }
});

// **************************** DESKTOP - ALL PRODUCTS PAGE ****************************

let mediaQuerySmallDevices = window.matchMedia("(max-width: 990px)");

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
            addArrowsToLabels();
            addArrowToSort();
        }
    });
});

const targetNode = document.querySelector(".facets-container");
if (targetNode) {
    observer.observe(targetNode, {
        childList: true,
        subtree: true,
    });
}

document.addEventListener("DOMContentLoaded", function () {
    addArrowsToLabels();
    addArrowToSort();
});

const filter_labels = document.getElementsByClassName("facets__summary-label");

function addArrowsToLabels() {
    if (filter_labels && filter_labels.length > 0) {
        for (let i = 0; i < filter_labels.length; i++) {
            const label = filter_labels[i];
            const nextSibling = label.nextElementSibling;

            if (!nextSibling || nextSibling.className !== "arrow") {
                const filter_arrow = document.createElement("span");
                filter_arrow.className = "arrow";
                filter_arrow.textContent = "▼";
                label.insertAdjacentElement("afterend", filter_arrow);
            }
        }
    }
}

const select_label = document.getElementsByClassName("select");

function addArrowToSort() {
    if (select_label && select_label.length > 0) {
        for (let i = 0; i < select_label.length; i++) {
            const label = select_label[i];
            const nextSibling = label.nextElementSibling;

            if (!nextSibling || nextSibling.className !== "arrow") {
                const arrow = document.createElement("span");
                arrow.className = "arrow";
                arrow.textContent = "▼";
                label.insertAdjacentElement("afterend", arrow);
            }
        }
    }
}

/* Rename products to Collections */
// Function to replace "products" with "Collections" and apply styles
function replaceProductsText(element) {
    if (element) {
        const currentText = element.textContent;
        let newText = "Items"
        if (window.location.pathname === "/collections/all") {
            newText = currentText.replace(/products/gi, "Treats");
        }
        else if (window.location.pathname === "/collections/collections") {
            newText = currentText.replace(/products/gi, "Collections");
        }
        else if (window.location.pathname === "/collections/singles") {
            newText = currentText.replace(/products/gi, "Singles");
        }
        element.textContent = newText;
        element.style.fontFamily = "Adobe Garamond Pro Reg";
    }
}

// Update text for desktop, mobile, and mobile-facets__count
document.addEventListener("DOMContentLoaded", () => {
    const productsWordDesktop = document.getElementById("ProductCountDesktop");
    const productsWordMobile = document.getElementById("ProductCount");
    const mobileFacetsCount = document.querySelector(".mobile-facets__count");

    replaceProductsText(productsWordDesktop);
    replaceProductsText(productsWordMobile);
    replaceProductsText(mobileFacetsCount);
});
// **************************** DESKTOP - CART ****************************
// Hide the wrapping checkbox if the cart is empty

const cartNoteMaxLength = 150;

// window.onload = (event) => {
//   document.getElementById("Cart-note").maxLength = cartNoteMaxLength;
//   const ptwBox = document.querySelector(".ptw-app-label");
//   if (ptwBox) {
//     handleGiftCheckbox();
//     const ptwContainer = document.querySelector(".ptw-app-gnote");
//     const sencondElement = document.querySelector(".ptw-message-note");
//     const newPtwElement = document.createElement("div");
//     newPtwElement.setAttribute("class", "ptw-custom-text");
//     newPtwElement.style.display = "none";
//     newPtwElement.innerHTML = `
//       <h2 class="">GIFT MESSAGE </h2><p>Your message will be handwritten on card stock (5.25" x 3.5").</p>
//     `;
//     ptwContainer.insertBefore(newPtwElement, sencondElement);
//     const giftCheckboxLabel = document.querySelector(
//       `label[for="ptw-gift-needed"]`
//     );
//     if (giftCheckboxLabel) {
//       // Update the inner HTML of the label with text and SVG
//       giftCheckboxLabel.innerHTML = `Add hand-written gift note? <svg id="ptw-gift-icon" fill="#000000" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M15.5 6a1.25 1.25 0 0 0-1.25-1.25h-1.06a2.19 2.19 0 0 0 .23-1A2.22 2.22 0 0 0 11.2 1.5 3.78 3.78 0 0 0 8 3.07 3.78 3.78 0 0 0 4.8 1.5a2.22 2.22 0 0 0-2.22 2.22 2.19 2.19 0 0 0 .23 1H1.75A1.25 1.25 0 0 0 .5 6v2.5h1.25v4.79A1.25 1.25 0 0 0 3 14.5h10a1.25 1.25 0 0 0 1.25-1.25V8.46h1.25zm-4.3-3.25a1 1 0 0 1 0 2H8.68a2.36 2.36 0 0 1 2.52-2zm-6.4 0a2.36 2.36 0 0 1 2.52 2H4.8a1 1 0 0 1 0-1.95zM1.75 6h4.37v1.21H1.75zm4.37 7.29H3V8.46h3.12zm1.26 0V6h1.24v7.29zm5.62 0H9.88V8.46H13zm1.25-6H9.88V6h4.37z"></path></g></svg>`;
//     } else {
//       // Remove console.error from commented code
//     }
//   }
// };

function handleGiftCheckbox() {
    const giftCheckbox = document.getElementById("add-gift-note-checkbox");
    if (giftCheckbox.checked) {
        document.querySelector(".toggle-gift-message-box").style.display = "block";
    }
    else {
        document.querySelector(".toggle-gift-message-box").style.display = "none";
    }
    // const giftCheckbox = document.getElementById("ptw-gift-needed");

    // // Check if the checkbox exists
    // if (!giftCheckbox) {
    //   // Remove console.error from commented code
    //   return;
    // }

    // // Add an event listener to monitor changes to the checkbox
    // giftCheckbox.addEventListener("change", function () {
    //   if (giftCheckbox.checked) {
    //     // Action to perform when the checkbox is checked
    //     document.getElementById("ptw-text-message").maxLength = 150;
    //     document.querySelector(".ptw-custom-text").style.display = "";
    //     // Add your logic here
    //   } else {
    //     // Action to perform when the checkbox is unchecked
    //     document.querySelector(".ptw-custom-text").style.display = "none";
    //   }
    // });

}

function limitCounter(message) {
    var countfield = document.getElementById("char-limit-counter");
    if (message.value.length > 0) {
        countfield.innerHTML =
            cartNoteMaxLength - message.value.length + " of " + cartNoteMaxLength + " characters remaining.";
    }
}

document.addEventListener("DOMContentLoaded", function () {
    // Check if the current URL path is /cart

    if (window.location.pathname === "/cart") {
        // Select the container element that holds the cart items
        var cartContainer = document.querySelector("#MainContent");

        // Function to toggle the visibility of the ptw-wrapin element based on cart status
        function togglePtwWrapin() {
            var emptyCartText = document.querySelector(".cart__empty-text");
            var ptwWrapin = document.getElementById("ptw-wrapin");

            if (
                emptyCartText &&
                emptyCartText.textContent.trim() === "Your cart is empty" &&
                getComputedStyle(emptyCartText).display !== "none"
            ) {
                // Hide the ptw-wrapin element if the cart is empty
                if (ptwWrapin) {
                    ptwWrapin.style.display = "none";
                }
            } else {
                // Show the ptw-wrapin element if there are items in the cart
                if (ptwWrapin) {
                    ptwWrapin.style.display = "";
                }
            }
        }

        // Run the toggle function initially
        togglePtwWrapin();

        // Set up a MutationObserver to watch for changes in the cart
        if (cartContainer) {
            var observer = new MutationObserver(togglePtwWrapin);
            observer.observe(cartContainer, {
                childList: true, // Detect changes to child elements (items added or removed)
                subtree: true, // Observe all descendant elements
            });
        }
    }
});

// **************************** MOBILE - NAVBAR ****************************

const menu = document.querySelector(".menu-drawer__navigation-container");

const menu_footer = document.createElement("div");

menu_footer.innerHTML = "<a class='contact-us-link' href=''>Contact us</a>";
menu_footer.className = "menu-footer";

if (menu) {
    menu.insertAdjacentElement("afterend", menu_footer);
}

// **************************** MOBILE - ABOUT MUZEO PAGE ****************************

const isCorrectPath = window.location.pathname === "/blogs/news";

if (mediaQuerySmallDevices.matches && isCorrectPath) {
    function moveHeadings() {
        const headings = document.querySelectorAll(".image-with-text__content h2");
        const destinationDivs = document.querySelectorAll(
            ".image-with-text__media-item"
        );

        if (destinationDivs.length < headings.length) {
            console.error("Not enough destination divs to move the headings.");
            return;
        }

        headings.forEach((heading, index) => {
            if (destinationDivs[index]) {
                destinationDivs[index].appendChild(heading);
            }
        });
    }

    moveHeadings();
}

// **************************** MOBILE - ADD TO SHOPPING BAG BUTTON  ****************************

document.addEventListener("DOMContentLoaded", function () {
    var ele = document.getElementsByClassName("ymq-b2b-qb-table-box");
    if (ele && ele.length > 0) {
        ele[0].style.visibility = 'hidden';
    }
});


let buy_button = document.querySelector(".quantity-and-buy-button");
let scrollTrigger = document.querySelector(".product__info-wrapper");

if (
    mediaQuerySmallDevices.matches &&
    window.location.pathname.includes("/products")
) {
    document.body.appendChild(buy_button);

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    buy_button.style.opacity = "1";
                    buy_button.style.transition = "0.1s";
                    /* buy_button.style.transform = 'translateY(0%);'
                        buy_button.style.transition = 'transform 0.3s ease-in-out'; */
                } else {
                    buy_button.style.opacity = "0";
                    buy_button.style.transition = "0.1s";
                    /* buy_button.style.transform = 'translateY(100%);'
                        buy_button.style.transition = 'transform 0.3s ease-in-out'; */
                }
            });
        },
        {
            rootMargin: `-${scrollTrigger.offsetHeight}px 0px 0px 0px`,
            threshold: 0,
        }
    );

    observer.observe(scrollTrigger);
}

// Function to check if the current URL matches the /products/* pattern
function isOnProductPage() {
    return window.location.pathname.includes("/products/");
}

// Function to remove the disabled property from buttons with the class "quantity__button"
function enableQuantityButtons() {
    const buttons = document.querySelectorAll("button.quantity__button");
    buttons.forEach((button) => {
        button.disabled = false; // Remove the disabled property
    });
}

// Execute only if we are on a /products/* page
if (isOnProductPage()) {
    document.addEventListener("DOMContentLoaded", enableQuantityButtons);
}

// **************************** COLLECTIONS PAGE ****************************
// Check if the current page is /collections/all
if (window.location.pathname === "/collections/all" || window.location.pathname === "/collections/collections" || window.location.pathname === "/collections/singles") {
    // Function to filter the dropdown options
    function filterOptions(selectElement, allowedOptions) {
        for (let i = selectElement.options.length - 1; i >= 0; i--) {
            const option = selectElement.options[i];

            // If the option value is not in the allowed list, remove it
            if (!allowedOptions.includes(option.value)) {
                selectElement.remove(i);
            }
        }
    }

    // Define the allowed options
    const allowedOptions = ["manual", "title-ascending"];

    // Function to replace "products" with "Collections" and apply styles
    // function replaceProductsText(element) {
    //   if (element) {
    //     const currentText = element.textContent;
    //     const newText = currentText.replace(/products/gi, "Items");
    //     element.textContent = newText;
    //     element.style.fontFamily = "Adobe Garamond Pro Reg";
    //     element.style.color = "rgb(var(--color-foreground))";
    //   }
    // }

    // Function to apply filtering and text replacement
    function applyChanges() {
        // Filter the desktop dropdown
        const desktopSelectElement = document.getElementById("SortBy");
        if (desktopSelectElement) {
            filterOptions(desktopSelectElement, allowedOptions);
        }

        // Filter the mobile dropdown
        const mobileSelectElement = document.getElementById("SortBy-mobile");
        if (mobileSelectElement) {
            filterOptions(mobileSelectElement, allowedOptions);
        }

        // Replace "products" text
        const productCountElement = document.querySelector(".product-count");
        replaceProductsText(productCountElement);
    }

    // Apply changes immediately
    applyChanges();

    // Set up a MutationObserver to watch for changes in the body
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === "childList") {
                // If new nodes are added, check if they contain our elements of interest
                mutation.addedNodes.forEach((node) => {
                    if (
                        node.nodeType === Node.ELEMENT_NODE &&
                        (node.id === "SortBy" ||
                            node.id === "SortBy-mobile" ||
                            node.querySelector("#SortBy") ||
                            node.querySelector("#SortBy-mobile") ||
                            node.classList.contains("product-count") ||
                            node.querySelector(".product-count"))
                    ) {
                        // Reapply changes
                        applyChanges();
                    }
                });
            }
        });
    });

    // Start observing the body for changes
    observer.observe(document.body, { childList: true, subtree: true });
}

// Add event listeners on page load
addEventListeners();
// Handle URL parameters and fragments
handleURL();

function checkSliderCounter() {
    const currentCounter = document.querySelector(".slider-counter--current");
    const totalCounter = document.querySelector(".slider-counter--total");
    const nextButton = document.querySelector(".slider-button--next");

    // Only proceed if all elements exist
    if (currentCounter && totalCounter && nextButton) {
        // If the current slider is equal to the total number of slides, hide the next button
        if (currentCounter.textContent === totalCounter.textContent) {
            nextButton.style.display = "none";
        } else {
            nextButton.style.display = "block";
        }
    }
}
// Only call checkSliderCounter initially and set up the observer if the slider exists
const currentCounter = document.querySelector(".slider-counter--current");
if (currentCounter) {
    checkSliderCounter();
    new MutationObserver(checkSliderCounter).observe(currentCounter, {
        childList: true,
    });
}

// **************************** Tabbed nav on account page  ****************************

function openTab(event, tabId) {
    // Remove active class from all tabs and content
    const tabs = document.querySelectorAll(".account-tab");
    const tabContents = document.querySelectorAll(".account-tab-content");

    tabs.forEach((tab) => tab.classList.remove("active"));
    tabContents.forEach((content) => content.classList.remove("active"));

    // Add active class to clicked tab and corresponding content
    event.currentTarget.classList.add("active");
    document.getElementById(tabId).classList.add("active");
}


// **************************** Custom nav banner text  ****************************

// Add CSS helper for mobile accordion visibility
document.addEventListener('DOMContentLoaded', function () {
    try {
        // Add CSS for mobile accordion visibility - use insertAdjacentHTML instead of appendChild
        const cssText = `
        <style>
            @media (max-width: 990px) {
                .mobile-visible,
                .panel.mobile-visible,
                .accordion + div[style*="display: block"],
                .accordion + div.mobile-visible {
                    display: block !important;
                    visibility: visible !important;
                    height: auto !important;
                    opacity: 1 !important;
                    overflow: visible !important;
                }
                
                .accordion {
                    cursor: pointer;
                    -webkit-tap-highlight-color: rgba(0,0,0,0);
                    user-select: none;
                    -webkit-user-select: none;
                    touch-action: manipulation;
                    position: relative;
                    z-index: 1;
                }
                
                .panel {
                    transition: none !important;
                    -webkit-transition: none !important;
                }
            }
        </style>`;

        // Insert the style directly into the head
        document.head.insertAdjacentHTML('beforeend', cssText);
    } catch (e) {
        console.error('Error adding mobile CSS:', e);
    }

    // Direct fix for mobile - add inline styles to all panel elements
    try {
        const isMobile = window.innerWidth <= 990 || /iPhone|iPad|iPod|Android|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if (isMobile) {
            // Process URL parameters first
            const urlParams = new URLSearchParams(window.location.search);
            const sectionParam = urlParams.get('section');

            if (sectionParam) {
                // Get all accordions and panels
                const allAccordions = document.querySelectorAll('.accordion');

                // First attempt - direct DOM manipulation
                const targetAccordion = document.getElementById(sectionParam);
                if (targetAccordion) {
                    const panel = targetAccordion.nextElementSibling;
                    if (panel) {
                        // Set multiple properties to ensure visibility
                        panel.style.display = 'block';
                        panel.style.visibility = 'visible';
                        panel.style.height = 'auto';
                        panel.classList.add('mobile-visible');

                        // Add a data attribute to mark it as open
                        panel.setAttribute('data-open', 'true');

                        // Update arrow
                        const arrow = targetAccordion.querySelector('.arrow');
                        if (arrow) arrow.textContent = '▲';
                    }
                }

                // Second attempt - use setTimeout to ensure it happens after other scripts
                setTimeout(function () {
                    const accordion = document.getElementById(sectionParam);
                    if (accordion) {
                        const panel = accordion.nextElementSibling;
                        if (panel) {
                            panel.style.cssText = 'display: block !important; visibility: visible !important; height: auto !important;';
                            panel.classList.add('mobile-visible');

                            // Force scroll to the section
                            accordion.scrollIntoView({ behavior: 'auto', block: 'start' });

                            // Adjust for header height
                            window.scrollBy(0, -100);
                        }
                    }
                }, 1000);
            }

            // Add direct click handlers to all accordion elements to ensure they work on mobile
            const allAccordions = document.querySelectorAll('.accordion');
            allAccordions.forEach(function (accordion) {
                // Remove any existing click handler to avoid duplicates
                const newAccordion = accordion.cloneNode(true);
                accordion.parentNode.replaceChild(newAccordion, accordion);

                // Add a new click handler
                newAccordion.addEventListener('click', function (e) {
                    const panel = this.nextElementSibling;
                    if (panel) {
                        if (panel.style.display === 'block') {
                            panel.style.display = 'none';
                            const arrow = this.querySelector('.arrow');
                            if (arrow) arrow.textContent = '▼';
                        } else {
                            panel.style.display = 'block';
                            const arrow = this.querySelector('.arrow');
                            if (arrow) arrow.textContent = '▲';
                        }
                    }
                });

                // Add touchend for iOS
                newAccordion.addEventListener('touchend', function (e) {
                    e.preventDefault();  // Prevent any default behavior
                    const panel = this.nextElementSibling;
                    if (panel) {
                        if (panel.style.display === 'block') {
                            panel.style.display = 'none';
                            const arrow = this.querySelector('.arrow');
                            if (arrow) arrow.textContent = '▼';
                        } else {
                            panel.style.display = 'block';
                            panel.style.visibility = 'visible';
                            panel.style.height = 'auto';
                            const arrow = this.querySelector('.arrow');
                            if (arrow) arrow.textContent = '▲';
                        }
                    }
                }, { passive: false });
            });
        }
    } catch (e) {
        console.error('Error applying mobile fixes:', e);
    }
});

// Directly initialize accordion visibility on load
(function () {
    // Helper function to directly apply accordion toggling
    function directlyProcessAccordions() {
        try {
            // Handle URL parameters for direct deep linking
            if (window.location.pathname.includes('/products/')) {
                const urlParams = new URLSearchParams(window.location.search);
                const sectionParam = urlParams.get('section');

                if (sectionParam) {
                    const accordion = document.getElementById(sectionParam);

                    if (accordion) {
                        // Get the panel
                        const panel = accordion.nextElementSibling;
                        const arrow = accordion.querySelector('.arrow');

                        if (panel) {
                            // Force panel open with multiple methods
                            panel.style.display = 'block';
                            panel.setAttribute('data-mobile-open', 'true');

                            // Update arrow
                            if (arrow) arrow.textContent = '▲';
                        }
                    }
                }
            }

            // For iPhone Safari
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                // Apply inline styles to all accordions to ensure proper touch handling
                const allAccordions = document.querySelectorAll('.accordion');
                allAccordions.forEach(function (acc) {
                    acc.style.cursor = 'pointer';
                    acc.style.webkitTapHighlightColor = 'transparent';
                    acc.style.position = 'relative';
                    acc.style.zIndex = '1';

                    // Set touch handlers directly in iOS
                    acc.ontouchend = function (e) {
                        const panel = this.nextElementSibling;
                        if (panel) {
                            if (panel.style.display === 'block') {
                                panel.style.display = 'none';
                                const arrow = this.querySelector('.arrow');
                                if (arrow) arrow.textContent = '▼';
                            } else {
                                panel.style.display = 'block';
                                const arrow = this.querySelector('.arrow');
                                if (arrow) arrow.textContent = '▲';
                            }
                        }
                    };
                });
            }
        } catch (err) {
            // Silent error handling
        }
    }

    // Process immediately and after a delay
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        directlyProcessAccordions();
    } else {
        document.addEventListener('DOMContentLoaded', directlyProcessAccordions);
    }

    // Also process on window load and after a delay
    window.addEventListener('load', function () {
        directlyProcessAccordions();
        setTimeout(directlyProcessAccordions, 1000);
    });

    // Process one more time after a longer delay
    setTimeout(directlyProcessAccordions, 1500);
})();

// Initialize Sentry if available
try {
    if (typeof Sentry !== 'undefined') {
        Sentry.init({
            dsn: "https://b3e1b6db3fa54227af02876a3b74e874@o520774.ingest.sentry.io/4504270511284224"
        });
    }
} catch (e) {
    // Create a fallback Sentry object to prevent errors
    window.Sentry = window.Sentry || {
        captureException: function () { },
        captureMessage: function () { }
    };
}
